import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
const PageTitle = (props) => {
  const { t } = useTranslation();
  return (
    <div className="wpo-breadcumb-area">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <div className="wpo-breadcumb-wrap">
              <h2 className="main-title">{props.pageTitle}</h2>
              <ul className="wpo-breadcumb-wrap">
                {" "} <li>{" "}
                  {" "} <Link to="/home">{t(`home`)}</Link> {" "} 
                </li>{" "} 
                <li>{" "} 
                  {" "}<span>{props.pagesub}</span>{" "}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageTitle;
